// Contratos de fornecedores (03/11/2026): the screens of erp/contratos (merged under "erp": t('erp.contracts.title')).
export default {
  contracts: {
    title: 'Contratos de fornecedores',
    subtitle: 'Prazos, reajustes e as contas a pagar de cada contrato.',
    new: 'Novo contrato',
    tabs: { list: 'Contratos', costs: 'Custos', invoices: 'Notas fiscais' },
    searchPlaceholder: 'Contrato, código ou fornecedor',
    statusFilter: 'Situação',
    typeFilter: 'Tipo',
    onlyAttention: 'Só o que pede atenção',
    emptyTitle: 'Nenhum contrato cadastrado',
    emptyText: 'Cadastre os contratos com fornecedores para acompanhar prazos, reajustes e gerar as contas a pagar sozinho.',
    export: 'Exportar CSV',
    alertSettings: 'Avisos',
    status: { draft: 'Rascunho', active: 'Vigente', ended: 'Encerrado', terminated: 'Rescindido' },
    types: { recurring: 'Mensalidade ou assinatura', rent: 'Aluguel', one_off: 'Serviço pontual', supply: 'Fornecimento (consumo variável)' },
    typeHints: {
      recurring: 'Software, internet, contabilidade: um valor a cada período.',
      rent: 'Aluguel e locação, com mês e índice de reajuste.',
      one_off: 'Obra, projeto ou consultoria: um valor em parcelas.',
      supply: 'Consumo variável: o valor é uma estimativa e o cobrado é comparado com ele.',
    },
    situation: {
      none: '',
      expiring: 'Termina em breve',
      decide: 'Decidir sobre a renovação',
      unrenewed: 'Venceu sem renovação',
    },
    columns: { code: 'Código', title: 'Contrato', supplier: 'Fornecedor', type: 'Tipo', amount: 'Valor', end: 'Término', status: 'Situação' },
    valueHidden: '—',
    noEnd: 'Sem data de término',
    periodicity: { monthly: 'mês', yearly: 'ano' },
    every: 'a cada',
    cards: {
      active: 'Vigentes',
      attention: 'Pedem atenção',
      drafts: 'Rascunhos',
      monthlyCost: 'Custo mensal',
      deadlines: 'Próximos prazos',
      noDeadlines: 'Nenhum prazo nos próximos meses.',
    },
    deadline: { end: 'Termina', expired: 'Venceu', decide: 'Última data para decidir', adjustment: 'Reajuste' },
    form: {
      titleNew: 'Novo contrato',
      titleEdit: 'Contrato {code}',
      readFromPdf: 'Preencher com a IA a partir do PDF',
      reading: 'Lendo o contrato…',
      readFromPdfHint: 'A IA lê o PDF e sugere os campos. Você confere antes de salvar.',
      readOk: 'Dados sugeridos pela IA: confira antes de salvar.',
      supplierNotFound: 'O fornecedor "{name}" ainda não está cadastrado: escolha ou cadastre.',
      supplier: 'Fornecedor',
      newSupplier: '+ Novo fornecedor…',
      type: 'Tipo de contrato',
      title: 'Nome do contrato',
      contractNumber: 'Nº do contrato do fornecedor',
      category: 'Centro de custo',
      categoryHint: 'Uma categoria do financeiro. Um contrato tem um só centro de custo.',
      noCategory: 'Escolha a categoria',
      amount: 'Valor',
      amountRecurring: 'Valor de cada cobrança',
      amountOneOff: 'Valor de cada parcela',
      amountSupply: 'Valor estimado de cada período',
      installments: 'Parcelas',
      periodicity: 'Cobrança',
      interval: 'A cada',
      intervalHint: '1 = todo período; 3 meses = trimestral.',
      startDate: 'Início',
      endDate: 'Término',
      endDateHint: 'Vazio = sem data de término.',
      dueDay: 'Dia do vencimento',
      dueDayHint: 'Vazio = o dia do início.',
      paymentMethod: 'Forma de pagamento',
      notes: 'Observações e cláusulas importantes',
      renewal: 'Renovação',
      autoRenew: 'Renova sozinho no fim do prazo',
      renewalMonths: 'Cada renovação dura (meses)',
      noticeDays: 'Aviso prévio (dias)',
      noticeHint: 'Quantos dias antes do fim é preciso avisar para não renovar ou rescindir.',
      adjustment: 'Reajuste',
      adjustmentIndex: 'Índice',
      adjustmentIndexPlaceholder: 'IPCA, IGP-M…',
      adjustmentMonth: 'Mês do reajuste',
      alertLeadDays: 'Avisar com antecedência de (dias)',
      alertLeadDaysHint: 'Vazio = o padrão da instituição ({days} dias).',
      requiresInvoice: 'O fornecedor emite nota fiscal todo mês',
      requiresInvoiceHint: 'O financeiro passa a ter uma fila para solicitar, registrar e conferir a nota de cada conta.',
      invoiceLeadDays: 'Avisar o financeiro com antecedência de (dias)',
      invoiceLeadDaysHint: 'Dias antes do vencimento de cada conta. Vazio = 5 dias.',
      lockedMoney: 'O valor e as datas de um contrato vigente mudam por uma nova versão (reajuste, aditivo ou renovação).',
      months: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
      noMonth: 'Sem reajuste',
      saveDraft: 'Salvar rascunho',
    },
    detail: {
      back: 'Contratos',
      activate: 'Ativar contrato',
      activateTitle: 'Ativar {code}?',
      activateText: 'As contas a pagar serão geradas no financeiro. Depois disso, valor e datas só mudam por uma nova versão.',
      edit: 'Editar',
      delete: 'Excluir rascunho',
      deleteTitle: 'Excluir {code}?',
      deleteText: 'O rascunho e os documentos anexados serão apagados.',
      newVersion: 'Nova versão',
      terminate: 'Rescindir',
      finish: 'Encerrar',
      finishTitle: 'Encerrar {code}?',
      finishText: 'O contrato terminou e não será renovado. As contas já geradas continuam.',
      summary: 'Resumo',
      versions: 'Versões',
      payables: 'Contas a pagar',
      documents: 'Documentos',
      supplier: 'Fornecedor',
      type: 'Tipo',
      category: 'Centro de custo',
      period: 'Vigência',
      amount: 'Valor',
      monthlyCost: 'Custo mensal',
      dueDay: 'Vencimento',
      paymentMethod: 'Forma de pagamento',
      contractNumber: 'Nº do fornecedor',
      renewal: 'Renovação',
      autoRenew: 'Renova sozinho por {months} meses',
      manualRenew: 'Renovação manual',
      notice: '{days} dias de aviso prévio',
      decisionDate: 'Última data para decidir',
      adjustment: 'Reajuste',
      nextAdjustment: 'Próximo reajuste',
      termination: 'Rescisão',
      terminationText: 'Rescindido em {date}: {reason}',
      terminationFee: 'Multa de {amount}',
      notes: 'Cláusulas e observações',
      noValues: 'Você não tem permissão para ver os valores.',
      versionKind: { original: 'Original', adjustment: 'Reajuste', amendment: 'Aditivo', renewal: 'Renovação' },
      versionFrom: 'a partir de {date}',
      versionPercent: '{percent}% ({index})',
      noPayables: 'As contas a pagar aparecem quando o contrato é ativado.',
      payableColumns: { number: 'Nº', due: 'Vencimento', amount: 'Valor', paid: 'Pago', status: 'Situação' },
      payableStatus: { open: 'Em aberto', paid: 'Pago', partial: 'Parcial', cancelled: 'Sem cobrança' },
      noChargeDefault: 'Sem cobrança neste período.',
      overdue: 'Vencida',
      noDocuments: 'Nenhum documento anexado.',
      addDocument: 'Anexar documento',
      documentKind: 'Tipo do documento',
      documentKinds: { contract: 'Contrato', amendment: 'Aditivo', proposal: 'Proposta', other: 'Outro' },
      documentVersion: 'Versão {number}',
      removeDocument: 'Remover {name}',
      download: 'Baixar {name}',
      uploaded: 'Documento anexado.',
      uploadError: 'Escolha um arquivo de até 8 MB.',
    },
    version: {
      title: 'Nova versão do contrato',
      kind: 'O que mudou',
      kinds: { adjustment: 'Reajuste', amendment: 'Aditivo', renewal: 'Renovação' },
      effectiveFrom: 'Vale a partir de',
      effectiveFromHint: 'As contas a pagar com vencimento desta data em diante, ainda não pagas, seguem o novo valor.',
      percent: 'Reajuste (%)',
      percentHint: 'Sugere o novo valor; você pode ajustar.',
      suggested: 'Valor sugerido: {amount}',
      amount: 'Novo valor',
      endDate: 'Novo término',
      reason: 'Motivo ou observação',
      index: 'Índice',
      preview: 'Ver o que muda',
      previewTitle: 'O que muda nas contas a pagar',
      previewNone: 'Nenhuma conta a pagar muda (o valor é o mesmo ou não há contas abertas).',
      previewLine: '{n} · {date}: {from} → {to}',
      skippedSettled: 'Já pagas, ficam como estão: {list}',
      skippedExceptions: 'Editadas sozinhas, ficam como estão: {list}',
      confirm: 'Confirmar nova versão',
      done: 'Nova versão registrada.',
    },
    // Texts shared by the payable's edit (PayableEditDialog) and by the payable screen (EntryContractLink).
    link: {
      slot: 'Parcela do contrato',
      slotLabel: '{number} · {date}',
      status: { open: 'Em aberto', settled: 'Paga', partial: 'Paga em parte' },
    },
    // Vincular a um contrato, a partir da conta a pagar (EntryDialog).
    payableLink: {
      title: 'Contrato',
      text: 'Esta conta é de um fornecedor com contrato vigente. Se ela é a cobrança de uma parcela, vincule: o contrato não cria outra no lugar. A conta mantém o próprio valor e a data.',
      contract: 'Contrato',
      chooseSlot: 'Escolha a parcela',
      link: 'Vincular ao contrato',
      linked: 'Conta vinculada ao contrato.',
      linkedByPerson: 'Esta conta foi vinculada por uma pessoa à parcela {number} do contrato.',
      unlink: 'Desvincular',
      unlinkTitle: 'Desvincular do contrato?',
      unlinkText: 'A conta volta a ser avulsa, com o próprio valor e a data, e o contrato gera de novo a parcela dele.',
      unlinked: 'Conta desvinculada. O contrato gerou a parcela de novo.',
    },
    payable: {
      title: 'Editar conta {number}',
      text: 'Só esta conta muda: reajustes futuros não a sobrescrevem. Para um mês sem cobrança, use "Sem cobrança".',
      chargeFrom: 'Cobrar a partir de',
      chargeFromHint: 'Para cobrar só os dias restantes do mês.',
      calculate: 'Calcular proporcional',
      suggestion: '{days} de {total} dias = {amount}',
      prorataNote: 'Proporcional: {days} de {total} dias do mês, a partir de {date}.',
      amount: 'Valor desta conta',
      due: 'Vencimento',
      note: 'Observação',
      noCharge: 'Sem cobrança',
      edit: 'Editar',
      saved: 'Conta atualizada.',
      cancelled: 'Conta cancelada (sem cobrança).',
      linkLabel: 'Conta já lançada',
      linkNone: 'Nenhuma (editar o valor e o vencimento desta conta)',
      linkOption: '{description} · venc. {due} · {amount} · {status}',
      linkText: 'Se a fatura deste fornecedor já foi lançada (ou paga), escolha-a aqui: ela ocupa esta conta, no lugar da gerada pelo contrato.',
      linkHint: 'A conta escolhida mantém o próprio valor e a data, e a conta gerada pelo contrato dá lugar a ela.',
      linkEmpty: 'Não há despesas deste fornecedor para vincular: só entram contas sem recorrência, parcelamento ou cartão.',
      linkConfirm: 'Vincular conta',
      linked: 'Conta vinculada ao contrato.',
    },
    terminate: {
      title: 'Rescindir contrato',
      text: 'As contas a pagar depois da data de rescisão que ainda não foram pagas serão canceladas.',
      date: 'Data da rescisão',
      reason: 'Motivo',
      fee: 'Multa prevista',
      feeHint: 'Vira uma conta a pagar na data da rescisão.',
      confirm: 'Rescindir',
      done: 'Contrato rescindido.',
    },
    alerts: {
      title: 'Avisos de prazo',
      text: 'Com quantos dias de antecedência avisar o fim do contrato, a última data para decidir e o reajuste. Cada contrato pode ter o seu.',
      leadDays: 'Antecedência padrão (dias)',
      who: 'Recebem quem tem a permissão "Receber alertas dos contratos": no sino e por e-mail, mais um resumo toda segunda-feira.',
      saved: 'Antecedência salva.',
    },
    forSupplier: {
      title: 'Contratos de {name}',
      action: 'Ver contratos de {name}',
      actionShort: 'Contratos',
      new: 'Novo contrato',
      empty: 'Nenhum contrato com este fornecedor',
      emptyText: 'Lance o primeiro: o fornecedor já vem escolhido.',
    },
    invoices: {
      title: 'Notas fiscais',
      hint: 'Uma linha por conta a pagar dos contratos que exigem nota fiscal: o que venceu nos últimos 90 dias e o que vence nos próximos 60.',
      hintContract: 'Uma linha por conta a pagar deste contrato. A nota registrada é comparada com o valor da conta.',
      all: 'Todas',
      statusFilter: 'Situação da nota',
      status: { pending: 'Sem nota', requested: 'Solicitada', received: 'Recebida: conferir', validated: 'Validada', divergent: 'Valor diferente' },
      sentBySupplier: 'Enviada pelo fornecedor em {date}',
      xmlSays: 'O XML diz: nota',
      recipientMismatch: 'O CNPJ do tomador no XML não é o da empresa',
      downloadXml: 'XML',
      linkUntil: 'Link do fornecedor até {date}',
      overdue: 'Atrasada',
      requestedAt: 'Pedida em {date} ({count}x)',
      difference: 'Diferença de {amount} em relação à conta',
      accepted: 'Aceita por {name}',
      columns: { contract: 'Contrato', competence: 'Competência', due: 'Vencimento', expected: 'Valor da conta', status: 'Nota', invoice: 'Nota recebida' },
      requestNote: 'Solicitar nota',
      requestAgain: 'Solicitar de novo',
      register: 'Registrar nota',
      accept: 'Aceitar valor',
      download: 'Baixar',
      empty: 'Nenhuma nota para acompanhar',
      emptyText: 'Marque "O fornecedor emite nota fiscal todo mês" no contrato para acompanhar as notas aqui.',
      noAccess: 'Você não tem permissão para cuidar das notas fiscais.',
      request: {
        title: 'Solicitar nota fiscal',
        text: 'Pedimos a nota de {month} para {supplier}, pelo e-mail e telefone do cadastro do fornecedor. Vai um link seguro (sem senha) para ele enviar o PDF e o XML, com os dados da empresa e o valor para emissão.',
        email: 'Por e-mail',
        whatsapp: 'Por WhatsApp',
        loading: 'Montando o texto',
        loadFailed: 'Não foi possível montar o texto agora.',
        retry: 'Tentar de novo',
        to: 'Para: {to}',
        subject: 'Assunto',
        emailText: 'Texto do e-mail',
        whatsappText: 'Mensagem do WhatsApp',
        linkHint: 'Você pode mudar o texto. {placeholder} é o lugar do link seguro do fornecedor: ele é criado na hora do envio e substitui esse trecho.',
        noLink: 'Esta instituição ainda não tem endereço próprio, então o pedido vai sem link: o fornecedor responde com os arquivos.',
        missingLink: 'Falta {placeholder} em um dos textos: ele vai sem o link para o fornecedor enviar a nota.',
        restore: 'Voltar ao texto padrão',
        send: 'Enviar pedido',
        done: 'Pedido enviado ({via}).',
        channels: { email: 'e-mail', whatsapp: 'WhatsApp' },
      },
      registerDialog: {
        title: 'Registrar nota fiscal',
        context: '{contract} · competência {month}.',
        expected: 'Valor da conta: {amount}.',
        number: 'Número da nota',
        date: 'Data da nota',
        amount: 'Valor da nota',
        differsHint: 'Diferente do valor da conta: a nota ficará como "valor diferente" até você aceitar.',
        attach: 'Anexar PDF da nota',
        attachXml: 'Anexar XML da nota',
        xmlReading: 'Lendo o XML',
        xmlFilled: 'Preenchemos o número, a data e o valor a partir do XML. Confira antes de registrar.',
        xmlPartial: 'Lemos o XML, mas ele não trazia: {missing}. Preencha à mão.',
        xmlFields: { number: 'o número', date: 'a data', amount: 'o valor' },
        xmlUnrecognized: 'Não reconhecemos este tipo de XML. O arquivo será guardado; preencha os dados à mão.',
        xmlInvalid: 'Este arquivo não é um XML válido.',
        files: 'Arquivos da nota',
        filesHint: 'Com o XML, os dados da nota são preenchidos sozinhos.',
        pdfAlready: 'Já há um PDF desta nota; enviar outro o substitui.',
        xmlAlready: 'Já há um XML desta nota; enviar outro o substitui.',
        notes: 'Observações',
        confirm: 'Registrar',
        validated: 'Nota registrada e validada: o valor confere com a conta.',
        divergent: 'Nota registrada, mas o valor está {amount} diferente da conta.',
      },
      acceptDialog: {
        title: 'Aceitar nota com valor diferente',
        text: 'A nota {number} veio com {amount}, {difference} de diferença da conta. A conta a pagar não muda; só registramos que você conferiu.',
        reason: 'Motivo',
        confirm: 'Aceitar',
        done: 'Nota aceita.',
      },
    },
    costs: {
      title: 'Custo dos contratos',
      groupBy: 'Agrupar por',
      supplier: 'Fornecedor',
      category: 'Categoria',
      from: 'De',
      to: 'Até',
      columns: { contracts: 'Contratos', contracted: 'Contratado', charged: 'Lançado', paid: 'Pago', open: 'Em aberto', difference: 'Diferença' },
      total: 'Total',
      export: 'Exportar CSV',
      hint: 'Contratado é o que os contratos dizem; Lançado é o que as contas a pagar dizem (muda quando uma conta é editada sozinha).',
      noValues: 'Os relatórios de custo precisam da permissão de ver os valores dos contratos.',
      empty: 'Nenhuma conta de contrato no período.',
    },
  },
}
